// @flow
/**
 * Vana KLPMS UI koodi kapseldus uue jaoks
 */
import type {ConvertedMeasurementType} from "./model";

class Legacy {
    static setGlobal(name, value) {
        window[name] = value;
    }

    static getGlobal(name) {
        return window[name];
    }

    static getDrow(wagonNr: number): ConvertedMeasurementType {
        return window.getDrow(wagonNr);
    }

    static debug(message: string): void {
        return window.debug(message);
    }
}

export default Legacy;
